import { BSModalTemplate } from '@components/BonusSystemCommon'
import { useCountdownFSBonusStore } from '@stores/countdownFSBonusStore'
import { buildGradientStyle } from '@utils/buildGradientStyle'
import { BonusSystemState } from 'game-ui-types'
import { CountdownFreeSpinsBonus as CountdownFreeSpinsBonusType } from '@amusnet/mgs-ws-client'
import React, { useState } from 'react'
import CFSEndBonus from './content/CFSEndBonus'
import CFSSingleBonus from './content/CFSSingleBonus'
import CFSFooter from './footer/CFSFooter'

const CountdownFreeSpinsBonus: React.FC = () => {
    const bonusSystemState = useCountdownFSBonusStore((state) => state.bonusSystemState)
    const bonuses = useCountdownFSBonusStore((state) => state.bonuses)
    const isModalOpened = useCountdownFSBonusStore((state) => state.isModalOpened)
    const setIsModalOpened = useCountdownFSBonusStore((state) => state.setIsModalOpened)

    const [selectedBonus, setSelectedBonus] = useState<CountdownFreeSpinsBonusType | undefined>()

    const gradient = buildGradientStyle(
        ['#93490B 0%', '#FEE880 40%', '#FFFBE6 49.56%', '#FEE880 60.06%', '#93490B 100%'],
        '90deg'
    )

    const renderContent = () => {
        switch (bonusSystemState) {
            case BonusSystemState.SINGLE_BONUS_INITIAL:
                return <CFSSingleBonus updateSelectedBonus={setSelectedBonus} />
            case BonusSystemState.END:
                return <CFSEndBonus />
        }
    }

    return (
        <BSModalTemplate
            isModalOpened={isModalOpened}
            setIsModalOpened={setIsModalOpened}
            titleKey="gameui.bonusSystem.countdownFreeSpinsTitle"
            body={renderContent()}
            footer={<CFSFooter bonus={selectedBonus} />}
            titleColor="black"
            gradient={gradient}
            bonuses={bonuses}
            bonusSystemState={bonusSystemState}
        />
    )
}

export default CountdownFreeSpinsBonus
